import IsPerformanceResourceSupported from './IsPerformanceResourceSupported';

/**
 * Returns latest marked performance resource entry by given name
 */
export default function safeGetEntriesByName(name: string) {
    return IsPerformanceResourceSupported ? performance.getEntriesByName(name).slice(-1)[0] : null;
}
